// extracted by mini-css-extract-plugin
module.exports = {"list":"FAQGroup_list_3UhbB"};